
const TennisLoader = () => {
    return (
        <div className="tennis-loader">
            🎾
        </div>
    )
}

export default TennisLoader